import { defineMessages } from 'react-intl';

export default defineMessages({
  cardTitle: {
    id: 'residentTransferCard.title',
    defaultMessage: 'Resident Transfer',
  },
  unit: { id: 'residentTransferCard.unit', defaultMessage: 'Unit' },
  floorPlan: {
    id: 'residentTransferCard.floorPlan',
    defaultMessage: 'Floor Plan',
  },
  reason: {
    id: 'residentTransferCard.reason',
    defaultMessage: 'Reason for Transfer',
  },
  transferDate: {
    id: 'residentTransferCard.transferDate',
    defaultMessage: 'Transfer Date',
  },
  detailsTitle: {
    id: 'residentTransferCard.detailsTitle',
    defaultMessage: 'Transfer Details',
  },
  requirementsTitle: {
    id: 'residentTransferCard.requirementsTitle',
    defaultMessage: 'Transfer Requirements',
  },
  actionsTitle: {
    id: 'residentTransferCard.actionsTitle',
    defaultMessage: 'Transfer Actions Completed',
  },
  editDetails: {
    id: 'residentTransferCard.editDetails',
    defaultMessage: 'Edit',
  },
  verifiedIncome: {
    id: 'residentTransferCard.verifiedIncome',
    defaultMessage: 'Verified income for new unit',
  },
  proratedPaid: {
    id: 'residentTransferCard.proratedPaid',
    defaultMessage: 'Resident paid prorate, when applicable',
  },
  collectedPriorUnitKeys: {
    id: 'residentTransferCard.collectedPriorUnitKeys',
    defaultMessage: 'Collected keys for prior unit',
  },
  pickedNewUnitKeys: {
    id: 'residentTransferCard.pickedNewUnitKeys',
    defaultMessage: 'Resident picked up keys for new unit',
  },
  statusComplete: {
    id: 'residentTransferCard.statusComplete',
    defaultMessage: 'Completed',
  },
  statusPending: {
    id: 'residentTransferCard.statusPending',
    defaultMessage: 'Pending',
  },
  completeTransfer: {
    id: 'residentTransferCard.completeTransfer',
    defaultMessage: 'Complete Transfer',
  },
  completeTransferNoPermission: {
    id: 'residentTransferCard.completeTransferNoPermission',
    defaultMessage: 'You do not have permission to perform this action.',
  },
  completeTransferFutureDate: {
    id: 'residentTransferCard.completeTransferFutureDate',
    defaultMessage:
      'This transfer can be completed on or after {transferDate}.',
  },
  completeTransferModalTitle: {
    id: 'residentTransferCard.completeTransferModalTitle',
    defaultMessage: 'Confirm Transfer',
  },
  completeTransferModalBody1: {
    id: 'residentTransferCard.completeTransferModalBody1',
    defaultMessage:
      'Completing this transfer will move the household out of its current ' +
      'unit and into Unit {unit} on {transferDate}.',
  },
  completeTransferModalBody2: {
    id: 'residentTransferCard.completeTransferModalBody2',
    defaultMessage:
      'Please confirm that possession of the prior unit has been received ' +
      'before completing the transfer.',
  },
  completeTransferModalBody3: {
    id: 'residentTransferCard.completeTransferModalBody3',
    defaultMessage: 'This action cannot be undone',
  },
  completeTransferConfirm: {
    id: 'residentTransferCard.completeTransferConfirm',
    defaultMessage: 'Confirm',
  },
  completeTransferDismiss: {
    id: 'residentTransferCard.completeTransferDismiss',
    defaultMessage: 'Cancel',
  },
  completeTransferSuccessTitle: {
    id: 'residentTransferCard.completeTransferSuccessTitle',
    defaultMessage: 'Success',
  },
  completeTransferSuccessMessage: {
    id: 'residentTransferCard.completeTransferSuccessMessage',
    defaultMessage: 'Transfer completed successfully.',
  },
  completeTransferErrorTitle: {
    id: 'residentTransferCard.completeTransferErrorTitle',
    defaultMessage: 'Error',
  },
  cancelTransfer: {
    id: 'residentTransferCard.cancelTransfer',
    defaultMessage: 'Cancel Transfer',
  },
  cancelTransferModalTitle: {
    id: 'residentTransferCard.cancelTransferModalTitle',
    defaultMessage: 'Cancel Transfer',
  },
  cancelTransferModalBody1: {
    id: 'residentTransferCard.cancelTransferModalBody1',
    defaultMessage:
      'This will cancel the active transfer and permanently remove the ' +
      'transfer lease, transfer certifications, and Notice to Vacate associated with it.',
  },
  // ENG-31072: a conventional transfer has no transfer certifications to remove.
  cancelTransferModalBody1Conventional: {
    id: 'residentTransferCard.cancelTransferModalBody1Conventional',
    defaultMessage:
      'This will cancel the active transfer and permanently remove the ' +
      'transfer lease and Notice to Vacate associated with it.',
  },
  cancelTransferModalBody2: {
    id: 'residentTransferCard.cancelTransferModalBody2',
    defaultMessage: 'Are you sure you want to cancel this transfer?',
  },
  cancelTransferConfirm: {
    id: 'residentTransferCard.cancelTransferConfirm',
    defaultMessage: 'Confirm',
  },
  cancelTransferDismiss: {
    id: 'residentTransferCard.cancelTransferDismiss',
    defaultMessage: 'Cancel',
  },
  cancelTransferNoPermission: {
    id: 'residentTransferCard.cancelTransferNoPermission',
    defaultMessage: 'You do not have permission to perform this action.',
  },
  editNoPermission: {
    id: 'residentTransferCard.editNoPermission',
    defaultMessage: 'You do not have permission to perform this action.',
  },
  cancelTransferSuccessTitle: {
    id: 'residentTransferCard.cancelTransferSuccessTitle',
    defaultMessage: 'Success',
  },
  cancelTransferSuccessMessage: {
    id: 'residentTransferCard.cancelTransferSuccessMessage',
    defaultMessage: 'Transfer Canceled. Lease removed successfully.',
  },
  cancelTransferErrorTitle: {
    id: 'residentTransferCard.cancelTransferErrorTitle',
    defaultMessage: 'Error',
  },
});
